import axiosInstance from '../services/AxiosInstance';

export function getPropertySummary() {
    return axiosInstance.get(`graph/property-summary`);
}

export function getPropertyCountByMonth() {
    return axiosInstance.get(`graph/property-monthly-listing-type-counts`);
}

export function getPropertyCountByState() {
    return axiosInstance.get(`graph/property-count-by-state`);
}

export function getPropertyCountByDistrict() {
    return axiosInstance.get(`graph/property-district-count-by-state`);
}
